"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _useScript = _interopRequireDefault(require("../../../useScript"));

var _styles = _interopRequireDefault(require("../../config/styles"));

var _options = _interopRequireDefault(require("../../config/options"));

var _helper = _interopRequireDefault(require("../../helper"));

var _style = _interopRequireDefault(require("../../style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultLocation = {
  //Qmerit
  lat: 33.659917923217414,
  lng: -117.7535490787679
};
var myCircle;
var mapStatic;

function initMap(_ref) {
  var element = _ref.element,
      target = _ref.target,
      bounds = _ref.bounds,
      props = _ref.props;

  if (element) {
    var options = _objectSpread(_objectSpread({}, _options["default"]["static"]), {}, {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: _styles["default"]
    });

    mapStatic = new google.maps.Map(element, options);

    if (_lodash["default"].has(props, 'locations') && _lodash["default"].isArray(props.locations)) {
      _helper["default"].createMarkers({
        locations: props.locations,
        bounds: bounds,
        map: mapStatic,
        fit: true
      });
    }

    _helper["default"].getCurrentLocation(function (position) {
      _helper["default"].createMyLocationMarker({
        position: position,
        bounds: bounds,
        map: mapStatic
      });
    }, function (error) {
      handleLocationError(props, error);
    });
  }
}

function StaticMap(props) {
  var mapContainer = /*#__PURE__*/_react["default"].createElement(_style["default"].Wrapper, null, /*#__PURE__*/_react["default"].createElement(_style["default"].Target, {
    id: "newMap"
  }));

  var bounds = new google.maps.LatLngBounds();

  if (props.loaded) {
    (0, _react.useEffect)(function () {
      initMap({
        element: document.getElementById('newMap'),
        target: 'newMap',
        props: props,
        bounds: bounds
      });
    });
  }

  return mapContainer;
}

StaticMap.propTypes = {
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    lat: _propTypes["default"].number.isRequired,
    lng: _propTypes["default"].number.isRequired,
    icon: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string.isRequired
  }).isRequired).isRequired
};
var _default = StaticMap;
exports["default"] = _default;